<template>
    <UploadDocumentosShared ref="uploadDocumentosShared" tipoCliente="Pessoa Jurídica" :Edicao="Edicao" />
</template>

<script>
import UploadDocumentosShared from '@/views/Cadastro/Shared/UploadDocumentos.vue'

export default {
    name: 'CadastroPJ_UploadDocumentos',
    components: { UploadDocumentosShared },
    props: ['Edicao'],
    methods: {
        proximaEtapa() {
            if (this.$refs.uploadDocumentosShared?.proximaEtapa) {
                this.$refs.uploadDocumentosShared.proximaEtapa();
            }
        },
        validarFormulario(submeter) {
            if (this.$refs.uploadDocumentosShared) {
                return this.$refs.uploadDocumentosShared.validarFormulario(submeter);
            }
            return true;
        }
    }
}
</script>
